// Reconciliacao da mensagem enviada (compartilhado entre as telas de chat).
//
// O backend grava o texto com " - <usuario>" no fim, entao o bubble otimista
// (texto puro, sem waid) nunca e igual ao que volta do servidor. Estas funcoes
// trocam o otimista pela linha real mesmo quando o id nao bate.

export const WA_DEDUPE_TAG = "wa-dedupe-diag-v3";

export function isPendingItem(item) {
  return String(item?.createdat || "").indexOf("Waiting") === 0;
}

export function isSameMessage(serverRow, item) {
  if (!serverRow || !item) {
    return false;
  }

  if (String(item.id) === String(serverRow.id)) {
    return true;
  }

  if (item.waid) {
    return false;
  }

  if (String(item.contactid) !== String(serverRow.contactid)) {
    return false;
  }

  const serverText = String(serverRow.message || "");
  const pendingText = String(item.message || "");

  if (!pendingText) {
    return serverText.indexOf(" - ") === 0;
  }

  if (serverText === pendingText) {
    return true;
  }

  return serverText.indexOf(pendingText) === 0 && /^\s*-\s+\S/.test(serverText.substring(pendingText.length));
}

export function mergeServerRow(prev, serverRow) {
  return [serverRow, ...prev.filter(item => !isSameMessage(serverRow, item))];
}

export function logDetailsDiag(page, details) {
  if (!details) {
    return;
  }

  const compact = details.slice(0, 12).map(item => ({
    id: item?.id,
    createdat: item?.createdat,
    userid: item?.userid,
    msgtype: item?.msgtype,
    waid: item?.waid ? "yes" : null,
    msg: String(item?.message || "").slice(0, 40)
  }));

  console.log("WA-DETAILS", page, WA_DEDUPE_TAG, JSON.stringify(compact));
}
